import { SanityCMSService } from '@/services/sanity-cms';
import useSWR from 'swr';

export const useCompany = () => {
    return useSWR('getCompany', SanityCMSService.getCompany, {
        dedupingInterval: 1800000,
    });
};
